import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// OpenAI TTS voices available
export const VOICE_OPTIONS = {
  alloy: { name: 'Alloy', description: 'Neutral and balanced' },
  echo: { name: 'Echo', description: 'Clear and professional' },
  fable: { name: 'Fable', description: 'Warm and expressive' },
  onyx: { name: 'Onyx', description: 'Deep and authoritative' },
  nova: { name: 'Nova', description: 'Energetic and engaging' },
  shimmer: { name: 'Shimmer', description: 'Soft and calm' }
};

// Generate speech using OpenAI TTS
export const generateSpeech = async (text, voice = 'onyx') => {
  try {
    const response = await axios.post(
      `${API}/voice/tts`,
      {
        text,
        voice,
        model: 'tts-1' // or 'tts-1-hd' for higher quality
      },
      {
        headers: getAuthHeaders(),
        responseType: 'blob'
      }
    );

    return response.data;
  } catch (error) {
    console.error('TTS generation failed:', error);
    throw error;
  }
};

// Play audio blob
export const playAudio = (audioBlob) => {
  return new Promise((resolve, reject) => {
    const audioUrl = URL.createObjectURL(audioBlob);
    const audio = new Audio(audioUrl);

    audio.onended = () => {
      URL.revokeObjectURL(audioUrl);
      resolve();
    };

    audio.onerror = (error) => {
      URL.revokeObjectURL(audioUrl);
      reject(error);
    };

    audio.play().catch(reject);
  });
};

// Transcribe audio using OpenAI Whisper
export const transcribeAudio = async (audioBlob) => {
  try {
    const formData = new FormData();
    formData.append('file', audioBlob, 'recording.webm');
    formData.append('model', 'whisper-1');

    const response = await axios.post(
      `${API}/voice/transcribe`,
      formData,
      {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response.data.text;
  } catch (error) {
    console.error('Transcription failed:', error);
    throw error;
  }
};

export default {
  generateSpeech,
  playAudio,
  transcribeAudio,
  VOICE_OPTIONS
};
